<template>
  <div>
    <Ethereum :callback="initialize" />
    <Header :isHome="isHome" :buttonMsg="buttonMsg"/>
    <PrivacyMain id="privacyMain" />
    <Footer id="footer" />
  </div>
</template>
<script>
import Ethereum from '/src/components/common/Ethereum.vue';
import Footer from '../home/components/Footer.vue';
import Header from '/src/pages/layout/Header.vue';
import PrivacyMain from './components/PrivacyMain.vue';

import { computed, ref, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter} from 'vue-router';

export default {
  components: {
    Ethereum,
    Header,
    PrivacyMain,
    Footer
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const isLoggedIn = computed(() => {
      return store.state.ethers.address;
    });

    const initialize = async () => {};

    const isHome = computed(() => {
      return router.currentRoute.value.path === '/';
    });

    const buttonMsg = computed(() => {
      return "MINT";
    });

    return {
      store,
      isHome,
      buttonMsg,
      isLoggedIn,
      initialize
    };
  }
};
</script>
